import { displayCondition } from './conditionDisplay'

// "Spares or Repair" is stored canonically as the grade 'Broken' (see
// ConditionPicker — its value is 'Broken', its label is 'Spares or Repair').
// The photography UI must surface the operator-facing label rather than the raw
// internal value. Other grades fall through to the shared display mapping
// (e.g. Mint → Like New). Display-only: the stored value stays 'Broken' so the
// warehouse-system create-draft still classifies it as Spares & Parts.
export function photographyConditionLabel(condition) {
  return condition === 'Broken' ? 'Spares or Repair' : displayCondition(condition)
}
